import { render, staticRenderFns } from "./selectTipoSincronizacao.vue?vue&type=template&id=1e570e08&"
import script from "./selectTipoSincronizacao.vue?vue&type=script&lang=js&"
export * from "./selectTipoSincronizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
